// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const salesCrmToken = (tokenObj) => tokenObj && tokenObj.access_token;

const salesCrmGetters = {
  salesCrmToken
};

export default salesCrmGetters;